import { render, staticRenderFns } from "./product-category-filter-main-item.vue?vue&type=template&id=06e3830f&scoped=true"
import script from "./product-category-filter-main-item.vue?vue&type=script&lang=js"
export * from "./product-category-filter-main-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e3830f",
  null
  
)

export default component.exports